<template>
	<section class="mt-0">
		<b-row>
			<b-col
				cols="12"
				v-if="usersAssigned"
			>
				<statistic-card-horizontal
					icon="UsersIcon"
					color="info"
					:statistic="usersAssigned"
					statistic-title="Analista asignado para la licitación"
				/>
			</b-col>

			<b-col cols="12">
				<b-card class="p-0">
					<b-row>
						<b-col
							cols="12"
							class="d-flex justify-content-between align-items-center mb-2"
						>
							<b-button
								variant="outline-primary"
								v-ripple.400="'rgba(113, 102, 240, 0.15)'"
								@click="openUsersApprovalsModal"
							>
								<feather-icon icon="UsersIcon" />
								<span class="text-nowrap ml-1">Usuarios & Aprobaciones</span>
							</b-button>
						</b-col>
					</b-row>

					<b-row>
						<b-col
							cols="12"
							class="mb-2"
						>
							<b-table
								class="table-sm"
								ref="refApprovalsTable"
								:fields="fields"
								:items="items"
								empty-text="No se encontraron registros coincidentes"
								show-empty
								responsive
								bordered
								fiexed
							>
								<template #cell(status)="data">
									<b-badge
										class="text-nowrap"
										:variant="data.item.status === true ? 'light-success' : data.item.status === false ? 'light-danger' : 'light-warning'"
										pill
									>{{ data.item.status === true ? 'APROBADO' : data.item.status === false ? 'RECHAZADO' : 'PENDIENTE' }}</b-badge>
								</template>

								<template #cell(approver_fullname)="data">
									<span class="text-nowrap">{{ data.item.approver_fullname || '-' }}</span>
								</template>

								<template #cell(approved_at)="data">
									<span class="text-nowrap">{{ formatStringToDate(data.item.approved_at) }}</span>
								</template>
							</b-table>
						</b-col>
					</b-row>
				</b-card>
			</b-col>
		</b-row>

		<b-modal
			ref="refUsersApprovalsModal"
			title-tag="div"
			header-bg-variant="primary"
			header-text-variant="white"
			top
			title="USUARIOS Y APROBACIONES"
			hide-footer
			no-close-on-backdrop
			no-close-on-esc
			size="xl"
		>
			<b-row class="mb-2">
				<b-col
					cols="12"
					md="6"
				>
					<b-form-group>
						<label>
							<strong>DPTO. APROBACIÓN JEFATURA</strong>
						</label>
						<b-form-input
							:value="approvalConfig.leadershipDeptName"
							disabled
							readonly
						/>
					</b-form-group>
				</b-col>
				<b-col
					cols="12"
					md="6"
				>
					<b-form-group>
						<label>
							<strong>DPTO. APROBACIÓN SUPERINTENDENCIA</strong>
						</label>
						<b-form-input
							:value="approvalConfig.superintendenceDeptName"
							disabled
							readonly
						/>
					</b-form-group>
				</b-col>
			</b-row>

			<b-row>
				<b-col>
					<b-table
						ref="refUsersApprovalsTable"
						:fields="usersApprovals.fields"
						:items="usersApprovals.items"
						empty-text="No se encontraron registros coincidentes"
						show-empty
						responsive
						bordered
						fiexed
					>
						<template #table-busy>
							<div class="text-center text-primary my-2">
								<b-spinner class="align-middle mb-1"></b-spinner>
								<div>
									<b>CARGANDO</b>
								</div>
							</div>
						</template>

						<template #cell(approval_type)="data">
							<div>
								<b-badge
									v-for="(type, idx) in data.item.approval_types"
									:key="idx"
									:variant="type.variant"
									pill
									class="mr-50 mb-25"
								>{{ type.label }}</b-badge>
							</div>
						</template>
					</b-table>
				</b-col>
			</b-row>
		</b-modal>
	</section>
</template>

<script>
import StatisticCardHorizontal from "@core/components/statistics-cards/StatisticCardHorizontal.vue"
import { formatStringToDate } from "@core/utils/filter"
import AppCollapse from "@core/components/app-collapse/AppCollapse.vue"
import AppCollapseItem from "@core/components/app-collapse/AppCollapseItem.vue"
import { ref, onMounted } from "@vue/composition-api"
import useNotifications from "@notifications"
import Ripple from "vue-ripple-directive"
import axios from "@axios"

export default {
	components: {
		AppCollapse,
		AppCollapseItem,
		StatisticCardHorizontal
	},
	directives: {
		Ripple
	},
	props: {
		requestId: {
			type: Number,
			required: true
		},
		departmentId: {
			type: Number,
			required: true
		}
	},
	setup(props) {
		// USE TOAST
		const { toastNotification } = useNotifications()

		const refApprovalsTable = ref(null)
		const fields = ref([])
		const items = ref([])
		const usersAssigned = ref("")
		const refUsersApprovalsModal = ref(null)
		const usersApprovals = ref({})
		const approvalConfig = ref({
			leadershipDeptName: "",
			superintendenceDeptName: ""
		})
		const departmentsList = ref([])

		const setData = (data) => {
			const styleColumns = { thClass: "text-center", tdClass: "text-center" }

			fields.value = [
				{ key: "level_name", label: "Tipo de Aprobación", ...styleColumns },
				{ key: "status", label: "Estado", ...styleColumns },
				{
					key: "approver_fullname",
					label: "aprobador",
					thClass: styleColumns.thClass
				},
				{ key: "approved_at", label: "Fecha Registro", ...styleColumns }
			]

			items.value = data.items
			usersAssigned.value = data.usersAssigned

			const selfDeptName = departmentsList.value.find(
				(d) => d.value === props.departmentId
			)?.label || ""

			if (data.approvalDepartments && data.approvalDepartments.length) {
				const leadership = data.approvalDepartments.find(
					(item) => item.approval_level_id === 1
				)
				const superintendence = data.approvalDepartments.find(
					(item) => item.approval_level_id === 2
				)
				approvalConfig.value.leadershipDeptName = leadership
					? leadership.department_name
					: selfDeptName
				approvalConfig.value.superintendenceDeptName = superintendence
					? superintendence.department_name
					: selfDeptName
			} else {
				approvalConfig.value.leadershipDeptName = selfDeptName
				approvalConfig.value.superintendenceDeptName = selfDeptName
			}
		}

		const getData = async () => {
			try {
				const payload = { request_id: props.requestId }
				const response = await axios.get(`/request-approvals/`, {
					params: payload
				})
				setData(response.data.requestApprovals)
			} catch (error) {
				toastNotification(error.response?.data?.message, false)
			}
		}

		const getDepartments = async () => {
			try {
				const { data } = await axios.get("/selectors/departments")
				departmentsList.value = data.departments
			} catch (error) {
				toastNotification(error.response?.data?.message, false)
			}
		}

		onMounted(async () => {
			await getDepartments()
			await getData()
		})

		const formatUsersApprovals = (rawItems) => {
			const styleColumns = { thClass: "text-center", tdClass: "text-center" }

			const fields = [
				{ key: "department", label: "Área", ...styleColumns },
				{ key: "user", label: "Usuario", thClass: styleColumns.thClass },
				{ key: "approval_type", label: "Tipo de Aprobación", ...styleColumns }
			]

			const items = rawItems.map((item) => {
				const types = []
				if (item.is_admin) {
					types.push({ label: "JEFATURA ADMIN. CONTRATOS", variant: "light-info" })
				}
				if (item.is_leadership && !item.is_admin) {
					types.push({ label: "JEFATURA", variant: "light-primary" })
				}
				if (item.is_superintendence) {
					types.push({ label: "SUPERINTENDENCIA", variant: "light-warning" })
				}

				const sortOrder = item.is_admin ? 0
					: (item.is_leadership && item.is_superintendence) ? 3
					: item.is_leadership ? 1
					: 2

				return {
					department: item.department,
					user: item.user,
					approval_types: types,
					_sortOrder: sortOrder
				}
			})

			items.sort((a, b) => a._sortOrder - b._sortOrder)

			return { fields, items }
		}

		const getUsersApprovals = async () => {
			try {
				const response = await axios.get(`/request-approvals/`, {
					params: { request_id: props.requestId }
				})
				const approvalDepts =
					response.data.requestApprovals.approvalDepartments || []
				const deptIds = new Set([props.departmentId])
				approvalDepts.forEach((d) => deptIds.add(d.department_id))

				const { data } = await axios.get(
					`/users/access?department_ids=${[...deptIds].join(",")}`
				)
				usersApprovals.value = formatUsersApprovals(data.userAccess?.items || [])
			} catch (error) {
				toastNotification(error.response?.data?.message, false)
			}
		}

		const openUsersApprovalsModal = async () => {
			await getUsersApprovals()
			refUsersApprovalsModal.value.show()
		}

		return {
			refApprovalsTable,
			refUsersApprovalsModal,
			items,
			fields,
			usersAssigned,

			usersApprovals,
			approvalConfig,

			formatStringToDate,
			openUsersApprovalsModal
		}
	}
}
</script>

<style lang="scss" scoped>
.description-content {
	min-height: 150px;
	overflow-y: auto;
}
</style>